<template>
    <v-select
        :label=label
        :items=augmented_choices
        :value="current_value"
        v-on:change="onChange"
        return-object
    />
</template>

<script>

const TestData = require("@/js/TestData.js");

export default {
    props: {
        label: {
            type: String,
            default: () => { return 'Timezone'; }
        },
        value: {
            type: String,
            default: () => { return 'America/Phoenix'; }
        }
    },

    data() {
        return {
            choices: TestData.getCommonTimeZones(),
            current_value: this.value,
        }
    },

    methods: 
    {
        onChange(new_value) 
        {
            if ( new_value.value == 'more-choices' )
            {
                this.choices = TestData.getAllTimeZones();
            }
            else
            {
                this.current_value = new_value.value;
                this.$emit('input', new_value.value);
            }
        },
    },

    computed:
    {
        // Make sure all choices are objects: {text, value}
        normalized_choices()
        {
            return this.choices.map((choice) =>
            ({
                'text': choice.text || choice,
                'value': choice.value || choice
            }));
        },

        // Make sure choices includes current value & "more choices" if appropriate
        augmented_choices()
        {
            let ret = this.normalized_choices;

            if (!this.normalized_choices
                .map((choice) => choice.value)
                .some((val) => val === this.current_value))
            {
                ret.push({
                    'text': this.current_value,
                    'value': this.current_value
                });
            }

            if (ret.length < 50)
            {
                ret.push({
                    'divider' : true,
                });

                ret.push({
                    'text' : 'More Choices',
                    'value' : 'more-choices',
                });
            }

            return ret;
        },
    }
}
</script>

<style lang="scss" scoped>

</style>